import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import TelstraUIVueSvg from '../TelstraUIVueSvg/TelstraUIVueSvg.vue';
import Button from '../Button/Button';

@Component({
  components: {
    TelstraUIVueSvg,
    Button,
  },
})
export default class TelstraUIVueDialog extends Vue {
  @Prop({ default: false }) loading!: boolean;
  @Prop({ required: true }) heading!: string;
  @Prop() text!: string;
  @Prop({ default: 'Cancel' }) cancelLabel!: string;
  @Prop({ default: 'OK' }) actionLabel!: string;
  @Prop({ default: true }) showCancel!: boolean;
  @Prop({ default: true }) showAction!: boolean;
  @Prop({ default: false }) isAlert!: boolean;
  @Prop() error!: string;
  @Prop({ default: true }) disableActionBtn!: boolean;

  isActive: boolean = false;

  show(): void {
    this.isActive = true;
  }

  hide(): void {
    this.isActive = false;
  }

  @Emit()
  onAction(): void {
    this.$emit('action');
  }
}
